// extracted by mini-css-extract-plugin
var _1 = "CommentPreview-module__animateUploadProgressBarWidth--cqcPS";
var _2 = "CommentPreview-module__animatedBackground--Splhc";
var _3 = "CommentPreview-module__singleEmoji--oqWv7";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "singleEmoji" }
